import ApiConstant from "../../constants/api.constants";
import Helpers from "../../utils/helpers";
import api from "../api";

const baseURL = process.env.REACT_APP_SERVER_ENDPOINT_AURA_CAMERA;

export const getAllVoluntarySurveysList = async () => {
  try {
    const response = await api.get(baseURL + ApiConstant.getVoluntarySurveySites);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const getVSurveyOverviewSummary = async (cameraSiteId:any,surveyDate:any,siteName:any) => {
  try {
    const response = await api.get(`${baseURL}${ApiConstant.getVoluntarySurveyOverview}?cameraSiteId=${cameraSiteId}&surveyDate=${surveyDate}&siteName=${siteName}`);
    if (response && response.data ) {
      return response.data;
    }
    //return summaryChartData;
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const pinnedandUnpinnedSites = async (cameraSiteId:any) => {
  try {
    const response = await api.put(`${baseURL}${ApiConstant.pinnedandUnpinned}?cameraSiteId=${cameraSiteId}`);
    if (response && response.data ) {
      return response.data;
    }

  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const getVSurveyInformation = async (cameraSiteId:any,surveyDate:any,siteName:any) => {
  try {
    const response = await api.get(`${baseURL}${ApiConstant.getVoluntarySurveyInformation}?cameraSiteId=${cameraSiteId}&surveyDate=${surveyDate}&siteName=${siteName}`);
    if (response && response.data ) {
      return response.data;
    }
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const getVSurveyHistory = async (cameraSiteId:any) => {
  try {
    const response = await api.get(`${baseURL}${ApiConstant.getVoluntarySurveyHistory}?cameraSiteId=${cameraSiteId}`);
    if (response && response.data ) {
      return response.data;
    }
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

export const downloadVoluntarySurveyDetails =  async (cameraSiteId:string, surveyDate:string) => {
  try {
    const response = await api.get(`${baseURL}${ApiConstant.downloadVoluntarySurveyDetails}?cameraSiteId=${cameraSiteId}&surveyDate=${surveyDate}`); 
    if (response && response.data ) {
      return response.data;
    }

  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const VoluntarySurveyService = {
    getAllVoluntarySurveysList,
    getVSurveyOverviewSummary,
    pinnedandUnpinnedSites,
    getVSurveyInformation,
    getVSurveyHistory,
    downloadVoluntarySurveyDetails
};

export default VoluntarySurveyService;
